import script from "./BilingualContentTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./BilingualContentTabs.vue?vue&type=script&setup=true&lang=js"

import "./BilingualContentTabs.vue?vue&type=style&index=0&id=b0d24342&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0d24342"]])

export default __exports__